// extracted by mini-css-extract-plugin
module.exports = {"reviewRatings":"styles-module--reviewRatings--2lwdw","item":"styles-module--item--1tsXu"};